// Do not modify this file by hand!
// Re-generate this file by running lit-localize
import { html } from "lit";
import { str } from "@lit/localize";
/* eslint-disable no-irregular-whitespace */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const templates = {
    h0fca6d6cbb0506c0: html `市場インテリジェンス`,
    h229e7d06093c2f3f: html `ESG と多様性`,
    h4b6568de605796be: html `取締役会とガバナンス`,
    h4e84df3b11ed9b4f: html `ヘルプとサポート`,
    h722c4148bfbe6706: html `教育と認定`,
    h85f4df4fdcb8beed: html `リスクとストラテジー`,
    hb6b70f369f25a7ac: html `コンプライアンスと倫理`,
    hc639dc8eaab7815d: html `問題と報告`,
    hcd22a6d6c40d8786: html `監査とアナリティクス`,
    "link-home": `Home`,
    "nav-section-home": `Home`,
    s032cd9f1245d3645: `Space`,
    s08e6d298452e8f68: `監査`,
    s0910fa68dccfcaa6: `Data Market Intelligence`,
    s0a860146c6f28d97: `キーボードショートカットダイアログを開く`,
    s0bae1af85a28bd4c: `Diligent Institute`,
    s0ccb779911d414a3: `資産インベントリ`,
    s14ba513bc8896c24: `ロボット`,
    s1534ff9f453525e1: `最初のセルを選択`,
    s175d37c8eb04d73e: `ダウンロード`,
    s1967ea0b8a2b6015: `選択したセルを実行`,
    s199f5853f4e718f7: `プロジェクト`,
    s24761a0cc8d9c0aa: `組織`,
    s299dc244af6aadff: `Customer Admin Boards`,
    s2aa747e75ad1b409: `Third-Party Manager`,
    s2b63dc08d32ccb09: `上にスクロール`,
    s2c2b04f2561a1d4b: `Analytics`,
    s2cfcd4e06c146db9: `組織スイッチャーダイアログを開く`,
    s2e109263b73c12d5: `ライセンス`,
    s34d94212c9758944: `ストラテジー`,
    s353873ecbaa3efe9: `左矢印`,
    s3736464cf8d6fa08: `サポート`,
    s392dc2954562a82b: `テキストエディター`,
    s39cccc90e6fe1d7f: `問題管理`,
    s3ab6763097d7412f: `Equity Invest`,
    s3d5b54e4d176209c: `最終スライド`,
    s3f809b62bcc2a44c: `ミッション コントロール`,
    s45efff328e4d0a4d: `組織を検索`,
    s460bf77c46d93bb4: `ショートカットダイアログを閉じる`,
    s469437ae00d48e37: `現在の行を展開`,
    s47de2481b149190a: `エンティティ`,
    s4802e47fe2e95134: `オプション`,
    s480d27b7a8b69ce5: `左にスクロール`,
    s49ca4bf0e63593da: `ダイアログを閉じる`,
    s4b10acae683d2978: `全画面`,
    s4b81aa9512692c4d: `サイドナビゲーションを折りたたむ`,
    s523eb9043213ff0d: `斜体`,
    s56410a6c80d5215c: `セルを下に移動`,
    s58622fa7922ed03b: `ヘルプメニューボタン`,
    s586d6bd2eca2da93: `ユーザー`,
    s5a41c3a63f1c18af: `プロファイル設定`,
    s5b56a21c08c842c4: `最初のスライド`,
    s5c1ecf88259b79f9: `プレゼンテーション`,
    s5cad0782f12d34b2: `Equity`,
    s5d9182f471cf98d1: `コンプライアンス マップ`,
    s5d929ff1619ac0c9: `検索`,
    s5db46d120dcba694: `評価`,
    s5e27738a2e8eb763: `サインイン`,
    s5e8250fb85d64c23: `閉じる`,
    s5febcd9b311c16fe: `右にスクロール`,
    s60565faf8db3a5cb: `これと、それより上のすべてのセルを実行する`,
    s62bc518b503d1c76: `下のセルを選択`,
    s63b6edf663b6a3c5: `以下のセルを追加`,
    s6d5cb7af3fa87c78: `タスクの追跡ツール`,
    s6db55a42bcb74cfc: `問題の追跡ツール`,
    s6fb3409caa74b0a4: `Ctrl`,
    s70113bbc33303a81: `ヘルプメニュー`,
    s7417792bbe720149: `やり直す`,
    s74cb3d66f6a668e1: `ドキュメント`,
    s7695095bb106d505: `Accuvio`,
    s7a4f059aaa029719: `Connect`,
    s7cfe12cd14df9950: `サインアウト`,
    s7db511600050e797: `これと、それより下のすべてのセルを実行する`,
    s7deaf226ff8b192c: `インストーラー`,
    s7e388025be643d0d: `Enter`,
    s7eb1e34fc5ece4cd: `プロファイルメニュー`,
    s884bcdca26998a48: `レポート`,
    s89365ba6fa5cdb97: `実行を停止`,
    s89ba33f94f92f3cc: `問題特定キャンペーン`,
    s8f4be9f086eb530f: `元に戻す`,
    s9021935bcdd703b9: `スライドパネルを開く`,
    s9373ade6d85b4388: `現在の行を圧縮`,
    s947f21967d65c480: `マーケットプレイス`,
    s9ab2385df7adbce0: `行を強調`,
    s9dd12575273ac110: `下にスクロール`,
    s9df9510d60035af3: `プロファイルメニューを開く`,
    s9f26843287bb592d: `グループ`,
    s9fda4232f5e1876a: `ヘルプを受ける`,
    sa05b93d8764f88ed: `リスク マネージャー`,
    sa103c8e0c776e11c: `キーボードショートカットをリクエスト`,
    sa153c163bc11460d: `アクティビティ センター`,
    sa35ed9234d3d66ce: `組織が見つかりません`,
    sa4bb7742cdfc214e: `Director Boards`,
    sa872b0bfe51f2d40: `組織構造`,
    saed6432f1517ea10: `資産管理`,
    saf7a5eef69e5bb59: `上矢印`,
    sb061ff5a347a296e: `プロファイル`,
    sb206d700d26b14ff: `下線`,
    sb21cca7db5de38f3: `ストーリーボード`,
    sb284cd019b430d1e: `アプリ固有のショートカットは使用できません。`,
    sb32c8490570a8831: `スライド概要`,
    sb4484b8d878dffff: `活動ログ`,
    sb752d83c4e4619bc: str `切り替え先 ${0}`,
    sb888017adf7992b9: `Diligent Academy`,
    sbd63362a31200ab4: `Launchpad に進む`,
    sbda32dab0c54ffdd: `次のスライド`,
    sbf84c104b8212e06: `上のセルを選択`,
    sc203eef710f83583: `このアプリの固有のショートカットはサポートしていません。`,
    sc2873891e8c3be68: `ロボット スクリプト エディター`,
    sc835e30bc3bdd2fd: `セルを上に移動`,
    sc8aa5792985e2ba3: `プラットフォーム設定`,
    sca1a826088564455: `リザルト`,
    sca442b5dc0fd394c: `下矢印`,
    scdd4399eeeacd8f4: `組織を切り替え`,
    sd0864ea6cb6ef22e: `Community`,
    sd0b6082239185272: `すべて選択`,
    sd1182e4e6a0ada64: `Policy Manager`,
    sd1b2ae9109b29cf0: `スライドのナビゲーション`,
    sd1c09a62f063a73b: `タスクマネージャー`,
    sd514ab1c93237dae: `保証計画`,
    sd76505ffae553332: `リサーチポータル`,
    sd81eecf773db25fc: `すべてのセルを連続して実行`,
    sd8f923198e0c5c6a: `End`,
    sd90a1e198e1ac71e: `Esc`,
    sd9fb2375a5c991c5: `このアプリで特定のショートカットはサポートされていませんが、ご提案いただける場合、当社までお知らせください。`,
    sdc599e1d5c823e75: `最後のセルを選択`,
    sdcc5f064d591aefd: `前のスライド`,
    se2faf168207b0a48: `フレームワーク`,
    se3b4c857f91f80d7: `キーボード ショートカット`,
    se65e4e6f3696e997: `トレーニング`,
    se93a3eaf86201ae7: `Shift`,
    sed2d45e3f811c81d: `基本`,
    see0ef54044d25a50: `Book Admin Boards`,
    sf0d3b85da03d1e55: `選択したセルを削除`,
    sf2d615b20d62225a: `スケジューラ`,
    sf41a0c89409353dc: `右矢印`,
    sf5597bb9f2103d2a: `アクティベーション`,
    sf7c0eba7c822e3d6: `太字`,
    sf95b10c03a2d5872: `サイドナビゲーションを開く`,
    sf993c3199fefcb9c: `Alt`,
    sf9b1c0661a02d9f9: `構成`,
    sfc6b9ce43d2c798c: `タイムシート`,
    sfe3d666017079dce: `BoardEffect`,
    "shortcuts-home": `Home`,
};
